module.exports = {"530622101":"白鹤滩镇","530622102":"大寨镇","530622103":"小河镇","530622104":"药山镇","530622105":"马树镇","530622106":"老店镇","530622107":"茂租镇","530622108":"东坪镇","530622109":"新店镇","530622110":"崇溪镇","530622111":"金塘镇","530622112":"蒙姑镇","530622203":"红山乡","530622205":"包谷垴乡","530622206":"中寨乡","530622209":"炉房乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/530622.json
// module id = 2391
// module chunks = 0